import { useQuery, useMutation } from "@tanstack/react-query";
import clientPortalAxiosInstance from "../../common/utilities/axios/clientPortalAxiosInstance";
import sleep from "sleep-promise";

export const useGetClientUserListByClientAccountIdQuery = ({
  clientAccountId,
}) => {
  return useQuery({
    queryKey: ["getClientUserListByClientAccountIdQuery", `${clientAccountId}`],
    queryFn: () => {
      // sleep(2000);
      return clientPortalAxiosInstance
        .get(`/User-Profile/clientTeam/${clientAccountId}`)
        .then((res) => {
          return res.data;
        });
    },
    // The query will not execute until the clientAccountId exists
    enabled: !!clientAccountId,
  });
};

// get languages list by client account id/client sub account id
export const useGetLanguageListByClientAccountOrClientSubAccountId = ({ ClientAccountOrClientSubAccountId }) => {
  return useQuery({
    queryKey: ["getLanguageListByClientAccountOrClientSubAccountId", `${ClientAccountOrClientSubAccountId}`],
    queryFn: () => {
      return clientPortalAxiosInstance
        .get(
          `/User-Profile/clientAcccount/GetClientAccountLanguageByAccountId/${ClientAccountOrClientSubAccountId}`
        )
        .then((res) => {
          return res.data;
        });
    },
    // The query will not execute until the Id exists
    enabled: !!ClientAccountOrClientSubAccountId,
  });
};

// api for getting client user subaccount details by account id
export const useGetSubAcccountByClientAccountIdQuery = ({ ClientAccountId }) => {
  return useQuery({
    queryKey: ["getSubAcccountByClientAccountIdQuery", `${ClientAccountId}`],
    queryFn: () => {
      // sleep(2000);
      return clientPortalAxiosInstance
        .get(
          `/User-Profile/clientAcccount/subAcccountDropdown/${ClientAccountId}`
        )
        .then((res) => {
          return res.data;
        });
    },
    // The query will not execute until the Id exists
    enabled: !!ClientAccountId,
  });
};

// api for getting(POST Method) client user subaccount details by account id
// export const usePostSubAccountByClientAccountIdMutation = () => {
//   return useMutation({
//     mutationFn: ({ ClientAccountId, loggedInUserId, roleId, isEnterpriseAdmin }) => {
//       return clientPortalAxiosInstance.post(
//         `/User-Profile/clientAcccount/subAcccountDropdown/${ClientAccountId}`,
//         {
//           "LoggedInUserId": loggedInUserId || "",
//           "RoleId": roleId || "",
//           "IsEnterpriseAdmin": isEnterpriseAdmin
//         }
//       );
//     },
//   });
// };

// api for getting client user details by id
export const useGetClientUserByIdQuery = ({ Id }) => {
  return useQuery({
    queryKey: ["getClientUserByIdQuery", `${Id}`],
    queryFn: () => {
      // sleep(2000);
      return clientPortalAxiosInstance
        .get(`/User-Profile/client/getClientUsersById/${Id}`)
        .then((res) => {
          return res.data;
        });
    },
    // The query will not execute until the Id exists
    enabled: !!Id,
  });
};

/**Mutations */
export const useViewClientUsersListMutation = () => {
  return useMutation({
    mutationFn: ({ loggedInUserId, roleId, isEnterpriseAdmin }) => {
      return clientPortalAxiosInstance.post(`/User-Profile/client/rolebasedGetClientUsers`, {
        "LoggedInUserId": loggedInUserId || "",
        "RoleId": roleId || "",
        "IsEnterpriseAdmin": isEnterpriseAdmin
      })
    },
  })
}

export const useGetClientAccountDropdownMutation = () => {
  return useMutation({
    mutationFn: ({ loggedInUserId, roleId, isEnterpriseAdmin }) => {
      return clientPortalAxiosInstance.post(`/User-Profile/clientAcccount/rolebasedAccountDropdown`, {
        "LoggedInUserId": loggedInUserId || "",
        "RoleId": roleId || "",
        "IsEnterpriseAdmin": isEnterpriseAdmin
      })
    },
  })
}
// api for create client user
export const useCreateClientUserMutation = () => {
  return useMutation({
    mutationFn: ({ body }) => {
      return clientPortalAxiosInstance.post(
        `/User-Profile/client/saveprofile`,
        body
      );
    },
  });
};

// // api for update client user
export const useUpdateClientUserMutation = () => {
  return useMutation({
    mutationFn: ({ body }) => {
      return clientPortalAxiosInstance.post(
        `/User-Profile/client/editprofile`,
        body
      );
    },
  });
};

// // api for delete client user
export const useDeleteClientUserMutation = () => {
  return useMutation({
    mutationFn: ({ isDeleteMode, isRemovedMode, Id }) => {
      return clientPortalAxiosInstance.delete(
        `/User-Profile/client/deleteClientUser/${Id}`, {
        data: {
          IsDeleteMode: isDeleteMode,
          IsRemovedMode: isRemovedMode
        }
      }
      );
    },
  });
};
